export class CustomerServiceConstants {
    

    static SEARCH_LOOKTYPES = [
        { 'name': 'FBO', 'value': 'FBO' },
        { 'name': 'Retail Customer', 'value': 'RETAIL' }, { 'name': 'FBO Orders', 'value': 'FBO_ORDERS' },
        { 'name': 'Retail Customer Orders', 'value': 'RETAIL_ORDERS' }];
    static MEMBER_TYPES = [
        { 'name': 'FBO', 'value': 'FBO' },
        { 'name': 'Preferred', 'value': 'PREFERRED' },
        { 'name': 'Retail Customer', 'value': 'RETAIL_CUSTOMER' }];

    static MEMBER_LEVELS = [
        { 'name': 'Associate Manager', 'value': 'ASSOCIATE_MANAGER' },
        { 'name': 'Manager', 'value': 'MANAGER' }
    ];
    static FBO_FIELDS = [
        { 'name': 'FBO ID', 'value': 'FBOID' },
        { 'name': 'Name', 'value': 'FIRSTNAME' }];

    static FBO_ORDER_FIELDS = [
        { 'name': 'FBO ID', 'value': 'FBOID' },
        { 'name': 'Order Number', 'value': 'ORDERNUMBER' }];

    static RETAIL_FIELDS = [
        { 'name': 'User Name', 'value': 'USERNAME' },
        { 'name': 'Email ID', 'value': 'EmailADDRESS' }];

    static RETAIL_ORDER_FIELDS = [
        { 'name': 'User Name', 'value': 'USERNAME' },
        { 'name': 'Order Number', 'value': 'ORDERNUMBER' }];

    static STATUSTYPES = [
        { 'name': 'All', 'value': 'All' },
        { 'name': 'Active', 'value': 'Active' },
        { 'name': 'Suspended', 'value': 'Suspended' },
        { 'name': 'Terminated', 'value': 'Terminated' }];

    static TICKETSOURCETYPES = [
        { 'name': 'Manual', 'value': 'Manual' },
        { 'name': 'Email', 'value': 'Email' },
        { 'name': 'FAX', 'value': 'FAX' }
    ];

    static TICKETPRIORITIES = [
        { 'name': 'Low', 'value': 'Low' },
        { 'name': 'Medium', 'value': 'Medium' },
        { 'name': 'High', 'value': 'High' }
    ];

    static TICKETTYPE = [
        { 'id': 1, 'name': 'Account', 'value': 'Account' },
        { 'id': 2, 'name': 'Bonus', 'value': 'Bonus' },
        { 'id': 3, 'name': 'Bonus reissue', 'value': 'Bonus reissue' },
        { 'id': 4, 'name': 'Email Ticket', 'value': 'Email Ticket' },
        { 'id': 5, 'name': 'Notes', 'value': 'Notes' },
        { 'id': 6, 'name': 'Orders', 'value': 'Orders' },
        { 'id': 7, 'name': 'Products', 'value': 'Products' },
        { 'id': 8, 'name': 'Services', 'value': 'Services' }
    ];

    static TICKETSUBTYPES = [
        { 'id': 1, 'name': 'Change of status', 'value': 'Change of status' },
        { 'id': 2, 'name': 'Request to change sponsor', 'value': 'Request to change sponsor' },
        { 'id': 3, 'name': 'Re-sponsorship', 'value': 'Re-sponsorship' },
        { 'id': 4, 'name': 'Termination/Suspension', 'value': 'Termination/Suspension' },
        { 'id': 5, 'name': 'Update info', 'value': 'Update info' }
    ];
    static TICKETSTATUSTYPES = [
        { 'id': 1, 'name': 'New', 'value': 'New' },
        { 'id': 2, 'name': 'In Progress', 'value': 'In Progress' },
        { 'id': 3, 'name': 'Closed', 'value': 'Closed' }
    ];
    static TICKETDEPARTMENTS = [
        { 'id': 1, 'name': 'Human Resource', 'value': 'Human Resource' }
    ];

    static TOTAl_PERMISSIONS = [ 'Create'
        , 'View'
        , 'Edit'
        , 'Delete'
        , 'Deactivate'
        , 'Assign'
    ];
    static AUTOSHIP_STATUS = [{ 'id': 1, 'name': 'Active' },
    { 'id': 2, 'name': 'Inactive' }
    ];
    static CHANGE_ORDER__STATUS = [{ id: 1, 'name': 'Shipped' },
    { 'id': 2, 'name': 'Completed' }
    ];

    static ORDER__SHIPPED_STATUS = [{ id: 4, 'name': 'Shipped' },
    { 'id': 5, 'name': 'Ready For Pickup' },  { 'id': 9, 'name': 'Completed' }
    ];
}



// WEBPACK FOOTER //
// ./src/app/common/constants/customer-service.constants.ts